export const scrollToTarget = (asPath = "") => {
  if (!asPath) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }
  const path = asPath.match(/#([a-z0-9-]+)/gi);
  if (path && path[0].includes("#")) {
    const id = path[0].replace("#", "");
    if (id) {
      const yOffset = -90;
      const el = document.querySelector("#" + id);
      if (el) {
        const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }
};

export const getBrowserDetect = (userAgent: string) => {
  const isFirefox = Boolean(userAgent.match(/Firefox/i));
  const isSafari = Boolean(userAgent.match(/Safari/i));
  const isMobile = {
    Android: function () {
      return userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
      return userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return userAgent.match(/IEMobile/i) || userAgent.match(/WPDesktop/i);
    },
    any: function () {
      return (
        isMobile.Android() ||
        isMobile.BlackBerry() ||
        isMobile.iOS() ||
        isMobile.Opera() ||
        isMobile.Windows()
      );
    },
  };

  return {
    isFirefox,
    isSafari,
    isMobile,
  };
};
